// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Page_wrapper__tR9wi","content":"Page_content__82Gu-"};